<template>
	<div class="variation-sidebar__wrapper">
    <div @click.self="toggleSidebar" class="variation-sidebar__backdrop"></div>
		<div class="variation-sidebar__container">
			<button @click="toggleSidebar" type="button" :aria-label="$translate('Ceres::Template.closeIcon')" class="close">
				<svg height="26" width="27"><use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
			</button>

			<div class="variation-sidebar__content">
				<portal-target name="sidebar"></portal-target>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			toggleSidebar(){
				document.body.classList.toggle("variation-sidebar--open");
			},
		}
	}
</script>
